module.exports = __webpack_public_path__ + "img/food.8124e170.jpeg";